import { FC } from "react";
import styles from "./ErrorPage.module.scss";

export const ErrorPage: FC<{ code?: number; message?: string }> = ({
  code = 500,
  message = "Es tut mir leid, dass beim Laden der Daten ein Fehler aufgetreten ist. Versuchen Sie es erneut :(",
}) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.code}>{code}</h1>
      <p className={styles.text}>{message}</p>
    </div>
  );
};
